import { InternalRule } from './useInternalRules';

export const receiptQuantityAppliedValidation: InternalRule = {
    name: 'receiptQuantityAppliedValidation',
    logic: (app) => {
        app.registerValidationFunction((state, results) => {
            if (state.type !== 'UserWorkflowActivityParams') {
                return;
            }

            // iterate through each line and check if the quantity applied matches the invoice line quantity
            state?.documentState?.BusinessDocFields?.Invoice?.InvoiceLineItems?.forEach((line, index) => {
                const invoiceLineQuantity = line?.Quantity;

                const receiptRoot = line?.MiscInfoXML?.root as any;
                const receipts = receiptRoot?.Receipts?.Receipt;

                const receiptList = receipts ? (Array.isArray(receipts) ? receipts : [receipts]) : undefined;

                const quantityApplied = receiptList?.reduce((acc: any, receipt: any) => {
                    return acc + receipt?.QuantityApplied;
                }, 0) as number;

                if (quantityApplied === undefined || invoiceLineQuantity === undefined) {
                    return;
                }

                if (quantityApplied != invoiceLineQuantity) {
                    results.addError({
                        message: 'The total quantity applied does not match the invoice line quantity.',
                        associatedField: app.services.associatedField.bodyField({
                            lineNumber: index + 1,
                            fieldName: 'MiscInfoXML',
                        }),
                    });
                }
            });
        });
    },
    fieldNamesToValidateOnFocusLoss: ['MiscInfoXML', 'Quantity'],
    eventsToValidateOn: [
        'FocusLossEvent',
        'WorkflowLoadEvent',
        'WorkflowReassignEvent',
        'WorkflowSaveEvent',
        'WorkflowSubmitEvent',
    ],
};
